import { useLocale } from "~/lib/hooks/useLocale";
import { COUNTRIES_WITHOUT_HOUSE_NUMBER } from "@commercekit/shared";
import { useMemo } from "react";

export const useHouseNumber = () => {
  const { locale } = useLocale();

  return useMemo(() => {
    return !COUNTRIES_WITHOUT_HOUSE_NUMBER.includes(locale.toLocaleLowerCase());
  }, [locale]);
};
